import { get } from "@ember/object"

export default function (payload, models) {
  return {
    courseTitle: get(models, "course.attributes.title"),
    planbookTitle: get(models, "planbook.attributes.title"),
    courseId: get(models, "course.id"),
    planbookId: get(models, "planbook.id"),
    userId: get(models, "user.id"),
    calledFrom: payload.calledFrom ? payload.calledFrom : null,
    date: payload.annotation
      ? payload.annotation.attributes.dateString
      : payload.dateString
      ? payload.dateString
      : null,
    annotationId: get(payload, "annotation.id"),
  }
}
